// Copyright 2020-2022 the Kubeapps contributors.
// SPDX-License-Identifier: Apache-2.0

import LoginForm from "./LoginForm";

export default LoginForm;
